// extracted by css-extract-rspack-plugin
export default {"hideOnNarrow":"responsive-module__hideOnNarrow__qF5nP","hideOnRegular":"responsive-module__hideOnRegular__TyqWM"};